'use strict';

var interact = require('interactjs');
var _ = require('lodash');
var ResizableFactory = function ResizableFactory() {
  var defaultOptions = {
    edges: {
      top: false,
      left: false,
      bottom: false,
      right: true
    }
  };
  function Resizable(selector, options) {
    this.options = _.defaultsDeep(options, defaultOptions);
    this.interactor = interact(selector).resizable(this.options);
  }
  Resizable.prototype.getInteractor = function () {
    return this.interactor;
  };
  return Resizable;
};
ResizableFactory.$inject = [];
module.exports = ResizableFactory;